module.exports = __webpack_public_path__ + "img/logo_landkreis_passau.c1dbf44.png";